export default {
    S1:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'más formas en que abordamos el acceso a la vivienda a precio asequible', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'más formas en que abordamos el acceso a la vivienda a precio asequible', // e.g., "more ways we're tackling housing affordability"
    },
    S2:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'obtén más información sobre nuestro compromiso con el acceso a la vivienda a precio asequible', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'obtén más información sobre nuestro compromiso con el acceso a la vivienda a precio asequible', // e.g., "more ways we're tackling housing affordability"
    },
    S3:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'recursos y educación adicionales', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'recursos y educación adicionales', // e.g., "more ways we're tackling housing affordability"
    },
    S4: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'map', 
        'siteSection': 'map',
    },
    S5: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'estamos comprometidos con nuestras comunidades', // e.g., "get insights and perspectives" 
        'siteSection': 'estamos comprometidos con nuestras comunidades', // e.g., "get insights and perspectives"
    },
    C1: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'más formas en que abordamos el acceso a la vivienda a precio asequible', // e.g., "get insights and perspectives" 
        'clickText': '150 millones'
       },
    C2: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'obtén más información sobre nuestro compromiso con el acceso a la vivienda a precio asequible', // e.g., "get insights and perspectives" 
        'clickText': '{{lower case subtitle}}'  //  e.g., "making homeownership accessible to all americans"
       },
    C3: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'recursos y educación adicionales', 
        'clickText': '{{lower case item title}}'  //  e.g., "low-to-moderate-income home loans"
    },
    C4: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'consulta el mapa (en inglés)'
       }, 
    C5: {
            'event': 'key-interaction',
            'lineOfBusiness': 'ent: interaction',
            'userActionTaken': 'learn more',
            'buttonLocation': 'mid', 
            'siteSection': 'estamos comprometidos con nuestras comunidades',
            'clickText': 'conoce más sobre otras maneras en las que estamos fortaleciendo nuestros vecindarios' 
    }
}